import type React from "react"

import { useState, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

export const useNavigation = () => {
  const navigate = useNavigate()
  const { tokenKey, wasLoggedIn, isBroker, isAdmin, decodeIdToken } = useAuth()

  // Estados para modales
  const [openAuthModal, setOpenAuthModal] = useState(false)
  const [openWelcomeBackModal, setOpenWelcomeBackModal] = useState(false)
  const [openBrokerProfileRequiredModal, setOpenBrokerProfileRequiredModal] = useState(false)
  const [openConvertModal, setOpenConvertModal] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(false)
  const [openRealEstateModal, setOpenRealEstateModal] = useState(false)
  const [openSettingsModal, setOpenSettingsModal] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  // Funciones de navegación
  const handleNavigate = useCallback(
    (path: string) => {
      navigate(path)
    },
    [navigate],
  )

  // Funciones de manejo de modales
  const handleAuthModalOpen = useCallback(() => {
    setOpenWelcomeBackModal(false)
    setOpenAuthModal(true)
  }, [])

  const handleAuthModalClose = useCallback(() => {
    setOpenAuthModal(false)
  }, [])

  const handleWelcomeBackModalOpen = useCallback(() => {
    const googleToken = localStorage.getItem("googleIdToken")
    if (googleToken) {
      decodeIdToken(googleToken)
    }
    setOpenWelcomeBackModal(true)
  }, [decodeIdToken])

  const handleWelcomeBackModalClose = useCallback(() => {
    setOpenWelcomeBackModal(false)
  }, [])

  const handleBrokerProfileRequiredModalOpen = useCallback(() => {
    setOpenBrokerProfileRequiredModal(true)
  }, [])

  const handleBrokerProfileRequiredModalClose = useCallback(() => {
    setOpenBrokerProfileRequiredModal(false)
  }, [])

  const handleConvertModalOpen = useCallback(() => {
    setOpenConvertModal(true)
  }, [])

  const handleConvertModalClose = useCallback(() => {
    setOpenConvertModal(false)
  }, [])

  const handleFilterModalOpen = useCallback(() => {
    setOpenFilterModal(false)
    setOpenFilterModal(true)
  }, [])

  const handleFilterModalClose = useCallback(() => {
    setOpenFilterModal(false)
  }, [])

  const handleOpenRealEstateModal = useCallback(() => {
    setOpenRealEstateModal(true)
  }, [])

  const handleCloseRealEstateModal = useCallback(() => {
    setOpenRealEstateModal(false)
  }, [])

  const handleOpenSettingsModal = useCallback(() => {
    setOpenSettingsModal(true)
  }, [])

  const handleCloseSettingsModal = useCallback(() => {
    setOpenSettingsModal(false)
  }, [])

  // Función de manejo del menú
  const handleMenuClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  // Función dinámica del botón principal
  const handleDynamicButtonClick = useCallback(
    (selectedTab = 0) => {
      if (tokenKey) {
        if ((isBroker || isAdmin) && selectedTab === 0) {
          handleNavigate("/properties/publish-property")
        } else if (selectedTab === 1) {
          handleNavigate("/posts/create-post")
        } else {
          handleBrokerProfileRequiredModalOpen()
        }
      } else {
        if (wasLoggedIn) {
          handleWelcomeBackModalOpen()
        } else {
          handleAuthModalOpen()
        }
      }
    },
    [
      tokenKey,
      isBroker,
      isAdmin,
      wasLoggedIn,
      handleNavigate,
      handleWelcomeBackModalOpen,
      handleAuthModalOpen,
      handleBrokerProfileRequiredModalOpen,
    ],
  )

    const handleAuthenticatedNavigation = useCallback(
    (path: string) => {
      if (tokenKey) {
        if (path === "properties/home") {
          handleNavigate("/properties/home")
        } else if (path === "posts/home") {
          handleNavigate("/posts/home")
        } else if (path === "messages") {
          handleNavigate("/messages")
        } else if (path === "favorites") {
          handleNavigate("/favorites")
        } else {
          handleNavigate(path)
        }
      } else {
        if (wasLoggedIn) {
          handleWelcomeBackModalOpen()
        } else {
          handleAuthModalOpen()
        }
      }
    },
    [tokenKey, wasLoggedIn, handleNavigate, handleWelcomeBackModalOpen, handleAuthModalOpen],
  )
  return {
    // Estados
    openAuthModal,
    openWelcomeBackModal,
    openBrokerProfileRequiredModal,
    openConvertModal,
    openFilterModal,
    openRealEstateModal,
    openSettingsModal,
    anchorEl,

    // Funciones de navegación
    handleNavigate,
    handleAuthenticatedNavigation,

    // Funciones de modales
    handleAuthModalOpen,
    handleAuthModalClose,
    handleWelcomeBackModalOpen,
    handleWelcomeBackModalClose,
    handleBrokerProfileRequiredModalOpen,
    handleBrokerProfileRequiredModalClose,
    handleConvertModalOpen,
    handleConvertModalClose,
    handleFilterModalOpen,
    handleFilterModalClose,
    handleOpenRealEstateModal,
    handleCloseRealEstateModal,
    handleOpenSettingsModal,
    handleCloseSettingsModal,

    // Funciones de menú
    handleMenuClick,
    handleMenuClose,

    // Función dinámica
    handleDynamicButtonClick,
  }
}
